export const emptyValue = '-';
